import { EventPeriod } from '@/constants';
import type { IPregameFeedDataAPI } from '@/types/feed';
import { Ref, ref } from 'vue';
import { AbstractFeed } from '@/models/abstractFeed';
import { BetItem } from '@/models/bet';
import { timeUntilEventKickoff } from '@/helpers/event';

export class FeedPregameItem extends AbstractFeed {
    public homeWinPercOpen: Ref<number | null>;
    public awayWinPercOpen: Ref<number | null>;
    public wldHomePriceOpen: Ref<string | null>;
    public wldAwayPriceOpen: Ref<string | null>;
    public wldDrawPriceOpen: Ref<string | null>;
    public leftUntilStart: Ref<number>;

    constructor(periodTypeId: EventPeriod, data: IPregameFeedDataAPI) {
        super(periodTypeId, data);

        this.homeWinPercOpen = ref(data.oHWinPerc ?? null);
        this.awayWinPercOpen = ref(data.oAWinPerc ?? null);
        this.wldHomePriceOpen = ref(data.wldHOpen ?? null);
        this.wldAwayPriceOpen = ref(data.wldAOpen ?? null);
        this.wldDrawPriceOpen = ref(data.wldDOpen ?? null);
        this.leftUntilStart = ref(data.leftUntilStart!);

        this.calculatePosition();
    }

    public update(data: Partial<IPregameFeedDataAPI>): void {
        super.update(data);
        if (data.oHWinPerc !== undefined) this.homeWinPercOpen.value = data.oHWinPerc;
        if (data.oAWinPerc !== undefined) this.awayWinPercOpen.value = data.oAWinPerc;
        if (data.wldHOpen !== undefined) this.wldHomePriceOpen.value = data.wldHOpen;
        if (data.wldAOpen !== undefined) this.wldAwayPriceOpen.value = data.wldAOpen;
        if (data.wldDOpen !== undefined) this.wldDrawPriceOpen.value = data.wldDOpen;
        if (data.leftUntilStart !== undefined) this.leftUntilStart.value = data.leftUntilStart;
    }

    public getEventScoreForBet(bet: BetItem): { home: number | null; away: number | null } {
        return { home: 0, away: 0 };
    }

    public getDateRemaining() {
        //console.log(`getDateRemaining execute for event ${this.teamHomeName.value}`);
        return timeUntilEventKickoff(this.leftUntilStart.value);
    }
}
